export default "__VITE_ASSET__BmB1a6_h__"